<template>
  <LLPage class="PrivacyPolicy">
    <template #breadcrumbs>
      <LLBreadCrumbs :crumbs="crumbs" />
    </template>
    <template #title>
      <h1 class="PrivacyPolicy__title">{{ $t('privacy_policy_title') }}</h1>
    </template>
    <template #content>
      <p class="PrivacyPolicy__date">{{ $t('privacy_policy_updated_at') }}</p>
      <PrivacyPolicyNL v-if="currentLanguage === 'nl'" />
      <PrivacyPolicyEN v-else-if="currentLanguage === 'en'" />
      <PrivacyPolicyFR v-else-if="currentLanguage === 'fr'" />
      <PrivacyPolicyKO v-else-if="currentLanguage === 'ko'" />
      <PrivacyPolicyJA v-else-if="currentLanguage === 'ja'" />
      <PrivacyPolicyES v-else-if="currentLanguage === 'es'" />
      <PrivacyPolicyDE v-else-if="currentLanguage === 'de'" />
      <PrivacyPolicyZH v-else-if="currentLanguage === 'zh'" />
      <PrivacyPolicyOtherLanguages v-else />
    </template>
  </LLPage>
</template>

<script>
import LLPage from '@/components/layout/LLPage'
import LLBreadCrumbs from '@/components/common/ui-components/LLBreadCrumbs'
import PrivacyPolicyNL from '@/components/pages/privacy-policy/languages/PrivacyPolicyNL'
import PrivacyPolicyOtherLanguages from '@/components/pages/privacy-policy/PrivacyPolicyOtherLanguages'
import PrivacyPolicyEN from '@/components/pages/privacy-policy/languages/PrivacyPolicyEN'
import PrivacyPolicyFR from '@/components/pages/privacy-policy/languages/PrivacyPolicyFR'
import PrivacyPolicyKO from '@/components/pages/privacy-policy/languages/PrivacyPolicyKO'
import PrivacyPolicyJA from '@/components/pages/privacy-policy/languages/PrivacyPolicyJA'
import PrivacyPolicyES from '@/components/pages/privacy-policy/languages/PrivacyPolicyES'
import PrivacyPolicyDE from '@/components/pages/privacy-policy/languages/PrivacyPolicyDE'
import PrivacyPolicyZH from '@/components/pages/privacy-policy/languages/PrivacyPolicyZH'
export default {
  name: 'PrivacyPolicy',
  components: {
    PrivacyPolicyDE,
    PrivacyPolicyES,
    PrivacyPolicyJA,
    PrivacyPolicyKO,
    PrivacyPolicyFR,
    PrivacyPolicyEN,
    PrivacyPolicyZH,
    PrivacyPolicyOtherLanguages,
    PrivacyPolicyNL,
    LLBreadCrumbs,
    LLPage
  },
  data() {
    return {}
  },
  computed: {
    crumbs() {
      return [{ name: this.$t('main_home_label'), path: '/' }, { name: this.$t('privacy_policy_title') }]
    },
    currentLanguage() {
      return this.$i18n.locale
    }
  }
}
</script>

<style lang="scss" scoped>
.PrivacyPolicy {
  &__date {
    @apply text-neutral-01 text-sm font-semibold mb-10;
  }
}
</style>
